import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MAIN_API_URL, isLoggedIn } from "./utils/auth";
import "../css/navBar.css";

export default function NavBarV2({ site_name }) {
  const location = useLocation();
  const navigate = useNavigate();
  const loggedIn = isLoggedIn();

  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    setDropdownOpen(false);
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      const refreshToken = localStorage.getItem("refresh");
      const accessToken = localStorage.getItem("access");

      const response = await fetch(`${MAIN_API_URL}/logout/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        credentials: "include",
        body: JSON.stringify({ refresh_token: refreshToken }),
      });

      if (response.ok) {
        localStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const isActive = (path) => (location.pathname === path ? "active-link" : "");

  return (
    <nav className="bookcase-navbar">
      <div className="nav-inner">
        <Link to={loggedIn ? "/authorsDesk" : "/"} className="nav-logo">
          {site_name}
        </Link>

        <button
          type="button"
          className="menu-btn"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
        >
          <div className={menuOpen ? "bar open" : "bar"}></div>
        </button>

        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          <Link
            to="/tools/generators"
            className={`nav-primary ${isActive("/tools/generators")}`}
          >
            Generators
          </Link>

          {loggedIn ? (
            <>
              <Link to="/dashboard" className={isActive("/dashboard")}>
                Home
              </Link>

              <Link to="/authorsDesk" className={isActive("/authorsDesk")}>
                Author’s Desk
              </Link>

              <Link to="/writersDen" className={isActive("/writersDen")}>
                Writer’s Den
              </Link>

              <Link to="/library" className={isActive("/library")}>
                Library
              </Link>

              <div className="nav-dropdown" ref={dropdownRef}>
                <button
                  type="button"
                  className="dropdown-label"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDropdownOpen((prev) => !prev);
                  }}
                >
                  Settings ▾
                </button>

                <div className={`dropdown-panel ${dropdownOpen ? "show" : ""}`}>
                  <Link
                    to="/settings/general"
                    className="dropdown-item"
                    onClick={() => setDropdownOpen(false)}
                  >
                    General
                  </Link>
                  <Link
                    to="/settings/notifications"
                    className="dropdown-item"
                    onClick={() => setDropdownOpen(false)}
                  >
                    Notifications
                  </Link>

                  <Link
                    to="/settings/privacy"
                    className="dropdown-item"
                    onClick={() => setDropdownOpen(false)}
                  >
                    Privacy
                  </Link>

                  <Link
                    to="/settings/support"
                    className="dropdown-item"
                    onClick={() => setDropdownOpen(false)}
                  >
                    Support
                  </Link>

                  <div className="dropdown-divider"></div>

                  <button
                    type="button"
                    className="dropdown-item logout-btn"
                    onClick={() => {
                      setDropdownOpen(false);
                      handleLogout();
                    }}
                  >
                    Log Out
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <Link to="/login" className={isActive("/login")}>
                Sign In
              </Link>

              <Link to="/register" className={isActive("/register")}>
                Create Account
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}